export default __webpack_public_path__ + "static/media/img-0177-spain-half-face.82e965aa.png";